import "../../assets/css/vendor-product-forms.css";
import ProductSpecificationFields from "../../components/ProductSpecificationFields";
import ProductSizeOptions from "../../components/ProductSizeOptions";
import { serialiseProductOptions } from "../../utils/productSizeOptions";
import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";
import DiscountFields, { discountPayloadOf } from "../../components/DiscountFields";
import { useProductFormGate } from "../../components/team/Gated";
import HeadOfficeProductNote from "../../components/branch/HeadOfficeProductNote";
import { MdAddAPhoto, MdWarning } from "react-icons/md";
import { Switch, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { uploadImageToCloudinary as sharedUpload } from "../../utilities/imageUpload";
import { toast } from "react-toastify";
import { getTokenFromLocalStorage } from "../../utilities/tokenUtils.js";
import { getUserFromLocalStorage } from "../../utilities/user.js";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { AppAsyncSelect as AsyncSelect } from "../../components/ui/AppReactSelect";
import MobileProductShootPicker from "../../components/MobileProductShootPicker";
import AdditionalImagesStrip from "../../components/AdditionalImagesStrip";
import ProductVideoSection from "../../components/ProductVideoSection";
import ArtworkTemplateLink from "../../components/ArtworkTemplateLink";
import UploadProgress from "../../components/UploadProgress";
import ProductFreightFields, {
  emptyProductFulfillment,
  serialiseProductFulfillment,
} from "../../components/ProductFreightFields";
import AppSelect from "../../components/ui/AppSelect";
import CategorySuggestions from "../../components/catalog/CategorySuggestions";
import UnitOptions from "../../components/catalog/UnitOptions";
import { categoryPickerOptions } from "../../utilities/catalogTaxonomy";
import { productPhotoHint } from "../../utilities/productPhotoRules";
import { vendorOwnerIdOf } from "../../utilities/vendorScope";

const API_URL = process.env.REACT_APP_SERVER_URL || "http://localhost:5000";
const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "lusuku";
const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "lusuku-clou";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "normal",
    fontSize: "12px",
    textTransform: "capitalize",
  },
}));

const adornedStyles = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.create-product-card-adorned {
  animation: fadeIn 0.5s ease-out;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.create-product-header-adorned {
  background: linear-gradient(135deg, #0a578bff 0%, #17385aff 100%) !important;
  color: white !important;
  padding: 32px !important;
  border: none !important;
  border-radius: 16px 16px 0 0 !important;
}

.create-product-body-adorned {
  padding: 32px !important;
  background: white;
}

.form-section-adorned {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.form-section-adorned:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.form-label-adorned {
  font-weight: 600 !important;
  color: #0a578bff !important;
  font-size: 14px !important;
  margin-bottom: 8px !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-adorned {
  border: 2px solid #e9ecef !important;
  border-radius: 8px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-adorned:focus {
  border-color: #0a578bff !important;
  box-shadow: 0 0 0 0.2rem rgba(10, 87, 139, 0.15) !important;
}

.btn-adorned-primary {
  background: #0a578bff !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
  box-shadow: 0 4px 12px rgba(10, 87, 139, 0.3) !important;
}

.btn-adorned-primary:hover {
  background: #17385aff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(10, 87, 139, 0.4) !important;
}

.btn-adorned-secondary {
  background: #6c757d !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.btn-adorned-secondary:hover {
  background: #5a6268 !important;
  transform: translateY(-2px);
}

.image-upload-card-adorned {
  border: 2px dashed #0a578bff !important;
  border-radius: 12px !important;
  background: #f8f9fa !important;
  transition: all 0.3s ease !important;
}

.image-upload-card-adorned:hover {
  border-color: #17385aff !important;
  background: #e9ecef !important;
}

.modal-adorned .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

.modal-adorned .modal-header {
  background: linear-gradient(135deg, #0a578bff 0%, #17385aff 100%) !important;
  color: white !important;
  border-radius: 16px 16px 0 0 !important;
  padding: 24px !important;
  border: none !important;
}

.modal-adorned .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modal-adorned .modal-title {
  font-weight: 700 !important;
  font-family: 'Inter', sans-serif !important;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`;

const generateSkuCode = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};

const normaliseCategoryOption = (category, knownCategories = []) => {
  if (!category) return null;

  if (typeof category === "object") {
    const id = category._id || category.value;
    const label =
      category.category ||
      category.label ||
      knownCategories.find((item) => String(item._id) === String(id))?.category;

    return id && label ? { ...category, _id: id, category: label } : null;
  }

  const match = knownCategories.find((item) => String(item._id) === String(category));
  return match || null;
};

const normaliseCategorySelection = (categories, knownCategories = []) =>
  (Array.isArray(categories) ? categories : [])
    .map((category) => normaliseCategoryOption(category, knownCategories))
    .filter(Boolean);

const CreateBrandProductForm = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const brandId = location.state?.brandId;
  const sectionId = location.state?.sectionId;
  const brandName = location.state?.brandName || "Brand";
  const vendorId = vendorOwnerIdOf(getUserFromLocalStorage());
  const token = getTokenFromLocalStorage();
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  const isMounted = useRef(true);
  // Stable for the lifetime of this form and deliberately unrelated to the
  // mutable product name. The media ledger keeps uploads under this temporary
  // identity until product creation commits and replaces it with the real id.
  const uploadEntityId = useRef(
    `pending-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
  );

  const [product, setProduct] = useState({
    name: "",
    description: "",
    price: 0.0,
    countInStock: 1,
    // Quantity + its siUnits ref, rendered together by the clients.
    measurements: 1,
    unit_id: null,
    image: null,
    /* Optional extra angles. Stored here as a mix of `data:` URLs (just
       picked) and `https://` URLs once uploaded — the submit handler
       resolves any dataURLs through Cloudinary before posting. Empty by
       default; the strip stays collapsed unless the vendor opts in. */
    additionalImages: [],
    /* Product videos — frozen contract entries, see ProductVideoSection. */
    videos: [],
    // Deactivated until QC activates it (see the model default).
    enabled: false,
    skuCode: generateSkuCode(),
    priceOnRequest: false,
    tierPrices: { retailer: "", wholesaler: "" },
    orderFlowOverride: "INHERIT",
    requiredPaymentMethod: "NONE",
    discount: null,
    minOrderQty: 1,
    leadTimeDays: "",
    // Product-owned fixed details and customer choices.
    specs: {},
    specOptions: [],
    fulfillment: emptyProductFulfillment(),
  });




  /* siUnits for the measurement dropdown, fetched the same relative way this
     form already fetches categories. `measurements` is a bare number on the
     product; without its unit the storefront renders "Measurements: 1", which
     is what every brand product in the database currently shows — neither
     field was on this form at all. */
  const [units, setUnits] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/unit");
        const data = await res.json();
        if (!cancelled && Array.isArray(data)) setUnits(data);
      } catch (err) {
        // Non-fatal — the product can still be saved without a unit.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const [priceWarning, setPriceWarning] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const gate = useProductFormGate(submitting || uploading);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  useEffect(() => {
    if (!brandId || !sectionId) {
      toast.error("Missing brand or section information. Redirecting...");
      history.push("/admin/brand-product-management");
    }

    return () => {
      isMounted.current = false;
    };
  }, [brandId, sectionId, history]);

  const fetchCategoryOptions = useCallback(async () => {
    try {
      const res = await fetch("/category/get-all");
      const categories = await res.json();
      return Array.isArray(categories) ? categories : [];
    } catch (error) {
      console.error("Error loading categories:", error);
      return [];
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const categories = await fetchCategoryOptions();
      if (!cancelled && isMounted.current) {
        setCategoryOptions(categories);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchCategoryOptions]);

  const loadCategory = useCallback(
    async (inputValue) => {
      const categories = await fetchCategoryOptions();
      // Grouped, "All"/"Random"/inactive left out, aliases and keywords searchable.
      return categoryPickerOptions(categories, { input: inputValue, selected: selectedCategory });
    },
    [fetchCategoryOptions, selectedCategory]
  );

  const handleCategoryChange = (value) => {
    setSelectedCategory(normaliseCategorySelection(value, categoryOptions));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "price") {
      if (parseFloat(value) < 0) {
        setPriceWarning("Please enter a Price higher than 0.");
        setProduct((prev) => ({ ...prev, [name]: "" }));
        return;
      } else {
        setPriceWarning("");
      }
    }

    if (name === "countInStock" && value < 1) {
      toast.error("Count in Stock cannot be less than 1");
      return;
    }

    /* Functional, never `{ ...product, ... }`. The spread copies the state
       as it was when THIS render happened, and a second update landing on
       top of it hands the form back the old values for everything else.
       That is how Prepayment Required (and any other field) snapped back
       to its default: the description editor below re-fires its onChange
       after a re-render, and it was carrying the previous copy. */
    setProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleTierChange = (tier, value) => {
    setProduct((prev) => ({ ...prev, tierPrices: { ...prev.tierPrices, [tier]: value } }));
  };

  /* ReactQuill calls onChange for its OWN re-renders too (source "api"), not
     only for typing (source "user"): when the value prop comes back after any
     other field changed, Quill normalises the HTML and reports it. Ignoring
     the api echoes is what stops a keystroke in one field being answered by a
     stale description write a frame later. */
  const handleDescriptionChange = (value, _delta, source) => {
    if (source && source !== "user") return;
    setProduct((prev) => ({ ...prev, description: value }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setUploadError("No file was selected.");
      return;
    }

    if (!file.type.startsWith("image/")) {
      setUploadError("Please select an image file.");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setUploadError("File size must be less than 10MB.");
      return;
    }

    setUploadError(null);
    const reader = new FileReader();
    reader.onload = () => {
      if (!isMounted.current) return;
      setImagePreview(reader.result);
      setProduct((prev) => ({ ...prev, image: reader.result }));
      setShowPreviewModal(true);
    };
    reader.onerror = () => {
      if (!isMounted.current) return;
      setUploadError("Failed to read the image file.");
      setImagePreview(null);
      setProduct((prev) => ({ ...prev, image: null }));
      setShowPreviewModal(false);
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToCloudinary = async (imageData, assetPurpose = "product_cover") => {
    if (!imageData) {
      toast.error("No image to upload!");
      return null;
    }

    setUploading(true);

    try {
      const result = await sharedUpload(imageData, {
        skipValidation: true,
        vendorMedia: {
          vendorType: "brand",
          vendorId: brandId,
          assetPurpose,
          entityType: "brandProduct",
          entityId: uploadEntityId.current,
          source: "dashboard",
          pendingAttachment: true,
        },
        onProgress: (percent) => {
          if (!isMounted.current) return;
          setUploadProgress(percent);
        },
      });

      const secureUrl = result.secure_url;
      if (!isMounted.current) return null;

      setUploading(false);
      return secureUrl;
    } catch (error) {
      if (!isMounted.current) return null;

      console.error("Error uploading image:", error);
      toast.error(`Failed to upload image: ${error.message}`);
      setUploading(false);
      return null;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let optionsPayload;
    try {
      optionsPayload = serialiseProductOptions(product.specOptions, product.price, product.priceOnRequest);
    } catch (error) {
      toast.error(error.message);
      return;
    }

    setUploading(true);
    setSubmitting(true);

    let uploadedImageUrl = product.image;
    if (
      uploadedImageUrl &&
      typeof uploadedImageUrl === "string" &&
      uploadedImageUrl.startsWith("data:")
    ) {
      uploadedImageUrl = await uploadImageToCloudinary(uploadedImageUrl);
      if (!uploadedImageUrl) {
        if (isMounted.current) {
          toast.error("Image upload failed, please try again.");
          setUploading(false);
          setSubmitting(false);
        }
        return;
      }
    } else if (!uploadedImageUrl) {
      if (isMounted.current) {
        toast.error("Please add an image to the product.");
        setUploading(false);
        setSubmitting(false);
      }
      return;
    }

    /* Resolve any newly-picked extra angles. Already-uploaded URLs pass
       straight through; dataURLs are pushed through the same Cloudinary
       upload helper as the cover image. A single failure aborts the
       submit so we never persist a half-uploaded gallery. */
    let resolvedAdditional = [];
    const picked = Array.isArray(product.additionalImages)
      ? product.additionalImages
      : [];
    for (const entry of picked) {
      if (typeof entry !== "string" || !entry) continue;
      if (entry.startsWith("data:")) {
        // eslint-disable-next-line no-await-in-loop
        const url = await uploadImageToCloudinary(entry, "product_angle");
        if (!url) {
          if (isMounted.current) {
            toast.error("One of the extra angles failed to upload.");
            setUploading(false);
            setSubmitting(false);
          }
          return;
        }
        resolvedAdditional.push(url);
      } else {
        resolvedAdditional.push(entry);
      }
    }

    /* Collected only for a product that publishes a price. A vendor who typed
       tier figures and then switched to "Price on request" had them submitted
       anyway, so the stored product contradicted itself: priceOnRequest true
       with a retailer tier beside it. Dropping them here means the
       contradiction is never written in the first place. */
    const tierPrices = {};
    if (!product.priceOnRequest) {
      if (product.tierPrices.retailer !== "") tierPrices.retailer = parseFloat(product.tierPrices.retailer);
      if (product.tierPrices.wholesaler !== "") tierPrices.wholesaler = parseFloat(product.tierPrices.wholesaler);
    }

    const brandProductData = {
      name: product.name,
      description: product.description,
      price: product.priceOnRequest ? 0 : parseFloat(product.price) || 0,
      image: uploadedImageUrl,
      additionalImages: resolvedAdditional,
      /* Contract-shaped entries; ProductVideoSection uploads on pick, so
         these are ready to persist as-is. */
      videos: Array.isArray(product.videos) ? product.videos : [],
      countInStock: parseInt(product.countInStock) || 1,
      measurements: Number(product.measurements) || 1,
      unit_id: product.unit_id || undefined,
      enabled: product.enabled,
      skuCode: product.skuCode || undefined,
      priceOnRequest: product.priceOnRequest,
      tierPrices: Object.keys(tierPrices).length ? tierPrices : undefined,
      orderFlowOverride: product.orderFlowOverride,
      requiredPaymentMethod: product.requiredPaymentMethod,
      discount: discountPayloadOf(product.discount),
      minOrderQty: parseInt(product.minOrderQty) || 1,
      leadTimeDays: product.leadTimeDays !== "" ? parseInt(product.leadTimeDays) : undefined,
      category: selectedCategory.map((category) => category._id),
      fulfillment: serialiseProductFulfillment(product.fulfillment),
      // Product-owned specifications and customer choices.
      specs: Object.keys(product.specs || {}).length ? product.specs : undefined,
      specOptions: optionsPayload,
    };

    try {
      const response = await axios.post(
        `${API_URL}/api/brands/${brandId}/sections/${sectionId}/products`,
        brandProductData,
        { headers: authHeaders }
      );

      if (isMounted.current) {
        toast.success("Product created successfully!");
        history.push("/admin/brand-product-management", {
          brandId,
          brandName,
        });
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error creating product:", error);
        toast.error(
          error.response?.data?.message ||
          "Failed to save product, please try again."
        );
        setSubmitting(false);
      }
    } finally {
      if (isMounted.current) {
        setUploading(false);
        setSubmitting(false);
      }
    }
  };

  if (!brandId || !sectionId) {
    return (
      <div className="content">
        <Alert variant="warning">
          Missing brand or section information. Please select a brand and
          section first.
        </Alert>
      </div>
    );
  }

  return (
    <Container className="vendor-product-form">
      <style>{adornedStyles}</style>
      <Row className="justify-content-center">
        <Col md={10}>
          <Card className="create-product-card-adorned">
            <Card.Header className="create-product-header-adorned">
              <Card.Title as="h3" style={{ marginBottom: 0, color: "white" }}>
                Create Brand Product - {brandName}
              </Card.Title>
              <p style={{ marginTop: "8px", marginBottom: 0, opacity: 0.9 }}>
                Add a new product to this brand's catalog
              </p>
            </Card.Header>
            <Card.Body className="create-product-body-adorned">
              {/* Vendor team permissions. Creating a product is catalogue:edit;
                  a pricing-only role can only read this form. */}
              {!gate.canCatalogue && (
                <Alert variant="warning" className="mb-3">
                  Your role does not allow creating products. The form is read-only.
                </Alert>
              )}
              <Form onSubmit={handleSubmit}>
                <HeadOfficeProductNote gate={gate} />
                {/* Renders the brand product template if an admin has
                    uploaded one, and nothing at all if not. */}
                <ArtworkTemplateLink slotKey="brand.productCover" />


                <Form.Group className="mb-4">
                  <Form.Label className="form-label-adorned">
                    Product Image *
                  </Form.Label>
                  <div className="image-upload-card-adorned p-4 text-center">
                    {!product.image ? (
                      <>
                        <Form.Control
                          type="file"
                          accept=".jpg, .png, .jpeg"
                          onChange={handleImageChange}
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          className="d-none"
                          id="image-upload"
                        />
                        <Form.Label
                          htmlFor="image-upload"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <MdAddAPhoto
                            size={48}
                            style={{ color: "#0a578bff" }}
                          />
                          <span
                            style={{ color: "#0a578bff", fontWeight: "600" }}
                          >
                            Click to upload image
                          </span>
                          <span style={{ fontSize: "12px", color: "#6c757d" }}>
                            {productPhotoHint()}
                          </span>
                        </Form.Label>
                      </>
                    ) : (
                      <div>
                        <img
                          src={imagePreview || product.image}
                          alt="Preview"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "300px",
                            borderRadius: "8px",
                            marginBottom: "12px",
                          }}
                        />
                        <div>
                          <Form.Control
                            type="file"
                            accept=".jpg, .png, .jpeg"
                            onChange={handleImageChange}
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                            className="d-none"
                            id="image-replace"
                          />
                          <Form.Label
                            htmlFor="image-replace"
                            as={Button}
                            variant="link"
                            style={{ color: "green", textDecoration: "none" }}
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          >
                            Replace Image
                          </Form.Label>
                          <span style={{ margin: "0 8px" }}>|</span>
                          <Button
                            variant="link"
                            style={{ color: "red", textDecoration: "none" }}
                            onClick={() => {
                              setProduct((prev) => ({ ...prev, image: null }));
                              setImagePreview(null);
                            }}
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          >
                            Remove Image
                          </Button>
                        </div>
                      </div>
                    )}
                    {uploadError && (
                      <Alert variant="danger" className="mt-2">
                        {uploadError}
                      </Alert>
                    )}
                    {uploading && (
                      <UploadProgress percent={uploadProgress} label="Uploading image" />
                    )}
                    <MobileProductShootPicker
                      vendorId={vendorId}
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      onSelectImage={(imageUrl) => {
                        setProduct((prev) => ({ ...prev, image: imageUrl }));
                        setImagePreview(imageUrl);
                        setUploadError(null);
                      }}
                    />
                  </div>
                  <AdditionalImagesStrip
                    value={product.additionalImages}
                    onChange={(next) =>
                      setProduct((prev) => ({ ...prev, additionalImages: next }))
                    }
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  />
                </Form.Group>

                <ProductVideoSection
                  videos={product.videos || []}
                  onChange={(next) =>
                    setProduct((prev) => ({ ...prev, videos: next }))
                  }
                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                />

                <Form.Group className="mb-3">
                  <Form.Label className="form-label-adorned">
                    Product Name *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={product.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter product name..."
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    className="form-control-adorned"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="form-label-adorned">
                    Category Association
                  </Form.Label>
                  {/* Same clipping trap as the edit form: this section sits in
                      a container with `overflow: hidden`, which cuts the menu
                      off at the card edge. Clipping is not a paint-order
                      problem, so z-index cannot fix it — the menu has to be
                      portalled out of the clipping ancestor. The z-index below
                      applies only once portalled, so the menu still beats
                      Bootstrap's overlay stack (modal 1050 → tooltip 1070). */}
                  <AsyncSelect
                    defaultOptions={categoryPickerOptions(categoryOptions, { selected: selectedCategory })}
                    value={selectedCategory}
                    getOptionLabel={(option) => option.category}
                    getOptionValue={(option) => option._id}
                    loadOptions={loadCategory}
                    onChange={handleCategoryChange}
                    isClearable
                    isMulti
                    isDisabled={submitting || uploading}
                    placeholder="Search and select categories..."
                    menuPortalTarget={
                      typeof document !== "undefined" ? document.body : null
                    }
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 1100 }),
                    }}
                  />
                  <CategorySuggestions
                    name={product.name}
                    unitId={product.unit_id}
                    vendorId={brandId}
                    categories={categoryOptions}
                    selected={selectedCategory}
                    disabled={submitting || uploading}
                    onAdd={(category) =>
                      setSelectedCategory((prev) =>
                        normaliseCategorySelection([...prev, category], categoryOptions)
                      )
                    }
                    onApplyUnit={
                      gate.lockCatalogue
                        ? undefined
                        : ({ _id, measurements }) =>
                            setProduct((prev) => ({ ...prev, unit_id: _id, measurements }))
                    }
                  />
                  <Form.Text className="text-muted" style={{ fontSize: "0.75rem" }}>
                    Used by the public shop to group this product with matching catalogue categories.
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="form-label-adorned">
                    Description (optional)
                  </Form.Label>
                  <ReactQuill
                    theme="snow"
                    value={product.description}
                    onChange={handleDescriptionChange}
                    placeholder="Enter product description..."
                    readOnly={submitting || uploading}
                    className="vendor-description-editor"
                  />
                </Form.Group>

                {/* Measurement + unit. Stored as a number plus an siUnits ref and
                    rendered together by the clients; a number on its own tells a
                    buyer nothing. */}
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="form-label-adorned">Measurement</Form.Label>
                      <Form.Control
                        type="number"
                        name="measurements"
                        min="0"
                        step="any"
                        value={product.measurements}
                        onChange={handleInputChange}
                        placeholder="e.g. 1000"
                        disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        className="form-control-adorned"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="form-label-adorned">Unit</Form.Label>
                      <AppSelect block
                        value={product.unit_id || ""}
                        onChange={(e) =>
                          setProduct((prev) => ({ ...prev, unit_id: e.target.value || null }))
                        }
                        disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        className="form-control-adorned"
                      >
                        <option value="">No unit</option>
                        <UnitOptions units={units} currentId={product.unit_id} />
                      </AppSelect>
                      <Form.Text className="text-muted" style={{ fontSize: "0.75rem" }}>
                        Buyers see “{product.measurements || 1}{" "}
                        {units.find((u) => String(u._id) === String(product.unit_id))?.unit ||
                          "(no unit)"}
                        ” on the product page.
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                {/* ── Pricing ─────────────────────────────────────── */}
                <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 20 }}>
                  <div style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "10px 16px", display: "flex", alignItems: "center", gap: 8 }}>
                    <i className="fas fa-tag" style={{ color: "#0a578b", fontSize: "0.85rem" }}></i>
                    <span style={{ fontWeight: 700, fontSize: "0.82rem", color: "#1a2f4e", textTransform: "uppercase", letterSpacing: "0.6px" }}>Pricing</span>
                  </div>
                  <div style={{ padding: 16 }}>
                    {/* Pricing mode */}
                    <div className="d-flex gap-3 mb-3">
                      {[
                        { val: false, label: "Fixed price", icon: "fas fa-dollar-sign", desc: "Set a specific UGX price displayed to all buyers." },
                        { val: true,  label: "Price on request", icon: "fas fa-comments-dollar", desc: "Hide the price. Buyers must contact you or request a quote." },
                      ].map(({ val, label, icon, desc }) => {
                        const active = product.priceOnRequest === val;
                        return (
                          <div
                            key={String(val)}
                            title={gate.pricingTitle}
                            onClick={() => !gate.lockPricing && setProduct((p) => ({ ...p, priceOnRequest: val }))}
                            style={{
                              flex: 1, border: `2px solid ${active ? "#0a578b" : "#e2e8f0"}`,
                              borderRadius: 8, padding: "12px 14px", cursor: "pointer",
                              background: active ? "#eff6ff" : "#fff", transition: "all 0.12s", userSelect: "none",
                              display: "flex", alignItems: "flex-start", gap: 10,
                            }}
                          >
                            <div style={{ width: 30, height: 30, borderRadius: 7, flexShrink: 0, background: active ? "#0a578b" : "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <i className={icon} style={{ fontSize: "0.8rem", color: active ? "#fff" : "#94a3b8" }}></i>
                            </div>
                            <div>
                              <div style={{ fontWeight: 700, fontSize: "0.82rem", color: active ? "#0a578b" : "#334155" }}>{label}</div>
                              <div style={{ fontSize: "0.72rem", color: "#64748b", marginTop: 2 }}>{desc}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Base price (hidden when priceOnRequest) */}
                    {!product.priceOnRequest && (
                      <Row className="g-3 mb-3">
                        <Col md={6}>
                          <Form.Label className="form-label-adorned">Base Price (UGX) *</Form.Label>
                          <Form.Control
                            type="number" name="price" value={product.price}
                            onChange={handleInputChange} required min="0" step="1"
                            placeholder="0" disabled={gate.lockPricing} title={gate.pricingTitle}
                            className="form-control-adorned"
                          />
                          {priceWarning && <Alert variant="danger" className="mt-2"><MdWarning size={18} className="me-1" />{priceWarning}</Alert>}
                        </Col>
                      </Row>
                    )}

                    {/* Tier prices. A per-buyer-type figure only means
                        something when there IS a published price to override,
                        so the whole block goes away once the vendor chooses
                        "Price on request". It used to stay on screen and keep
                        submitting, which let one SKU be saved saying both "ask
                        us for a price" and "retailers pay 12,500", and told the
                        vendor two different things at once while they filled
                        the form. The submit handler drops the values to match. */}
                    {!product.priceOnRequest && (
                      <div style={{ background: "#f0f7ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "12px 14px", marginBottom: 4 }}>
                        <div style={{ fontWeight: 700, fontSize: "0.78rem", color: "#0a578b", marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                          <i className="fas fa-layer-group" style={{ fontSize: "0.75rem" }}></i> Tier Pricing (optional)
                          <span style={{ fontWeight: 400, color: "#64748b", fontSize: "0.72rem" }}>overrides the base price per buyer type</span>
                        </div>
                        <Row className="g-2">
                          {[
                            ["retailer", "Retailer", "Buyers who purchase individual units or small quantities to resell in their own shop."],
                            ["wholesaler", "Wholesaler", "Buyers who purchase in bulk, typically to resell or distribute at scale."],
                          ].map(([tier, label, hint]) => (
                            <Col md={6} key={tier}>
                              <Form.Label className="small mb-1" style={{ color: "#374151" }}>{label.toUpperCase()}</Form.Label>
                              <Form.Control
                                size="sm" type="number" min="0" step="1"
                                placeholder="Leave blank to use base price"
                                value={product.tierPrices[tier]}
                                onChange={(e) => handleTierChange(tier, e.target.value)}
                                disabled={gate.lockPricing} title={gate.pricingTitle}
                              />
                              <div style={{ fontSize: "0.7rem", color: "#94a3b8", fontStyle: "italic", marginTop: 3 }}>{hint}</div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )}
                  </div>
                </div>

                {/* ── Inventory & Fulfilment ───────────────────────── */}
                <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 20 }}>
                  <div style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", padding: "10px 16px", display: "flex", alignItems: "center", gap: 8 }}>
                    <i className="fas fa-boxes" style={{ color: "#057a55", fontSize: "0.85rem" }}></i>
                    <span style={{ fontWeight: 700, fontSize: "0.82rem", color: "#1a2f4e", textTransform: "uppercase", letterSpacing: "0.6px" }}>Inventory &amp; Fulfilment</span>
                  </div>
                  <div style={{ padding: 16 }}>
                    <Row className="g-3 mb-3">
                      <Col md={4}>
                        <Form.Label className="form-label-adorned">Count in Stock *</Form.Label>
                        <Form.Control
                          type="number" name="countInStock" value={product.countInStock}
                          onChange={handleInputChange} required min="1" placeholder="1"
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle} className="form-control-adorned"
                        />
                      </Col>
                      <Col md={4}>
                        <Form.Label className="form-label-adorned">Min. Order Qty</Form.Label>
                        <Form.Control
                          type="number" name="minOrderQty" value={product.minOrderQty}
                          onChange={handleInputChange} min="1" placeholder="1"
                          disabled={gate.lockPricing} title={gate.pricingTitle} className="form-control-adorned"
                        />
                        <div style={{ fontSize: "0.7rem", color: "#94a3b8", fontStyle: "italic", marginTop: 3 }}>
                          The smallest number of units a buyer must order at once.
                        </div>
                      </Col>
                      <Col md={4}>
                        <Form.Label className="form-label-adorned">Lead Time (days)</Form.Label>
                        <Form.Control
                          type="number" name="leadTimeDays" value={product.leadTimeDays}
                          onChange={handleInputChange} min="0" placeholder="e.g. 5"
                          disabled={gate.lockCatalogue} title={gate.catalogueTitle} className="form-control-adorned"
                        />
                        <div style={{ fontSize: "0.7rem", color: "#94a3b8", fontStyle: "italic", marginTop: 3 }}>
                          How many days it typically takes to prepare and dispatch this product after an order is placed.
                        </div>
                      </Col>
                    </Row>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Label className="form-label-adorned">SKU Code</Form.Label>
                        <div style={{ display: "flex", gap: 6 }}>
                          <Form.Control
                            size="sm" name="skuCode" value={product.skuCode}
                            onChange={handleInputChange} placeholder="e.g. A3K9F"
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle} className="form-control-adorned"
                            style={{ fontFamily: "monospace", letterSpacing: "0.08em" }}
                          />
                          <button
                            type="button"
                            title="Re-generate SKU"
                            onClick={() => setProduct((p) => ({ ...p, skuCode: generateSkuCode() }))}
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                            style={{ flexShrink: 0, background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 6, padding: "0 10px", cursor: "pointer", fontSize: "0.8rem", color: "#0a578b" }}
                          >
                            ↻
                          </button>
                        </div>
                        <div style={{ fontSize: "0.7rem", color: "#94a3b8", fontStyle: "italic", marginTop: 3 }}>
                          Auto-generated — unique code used to track this product in orders and inventory. You can edit it or regenerate.
                        </div>
                      </Col>
                      <Col md={6}>
                        <Form.Label className="form-label-adorned">Order Flow Override</Form.Label>
                        <AppSelect block
                          size="sm" name="orderFlowOverride" value={product.orderFlowOverride}
                          onChange={handleInputChange} disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          className="form-control-adorned"
                        >
                          <option value="INHERIT">Inherit from brand settings</option>
                          <option value="STANDARD">Standard catalogue</option>
                          <option value="BRANDED_PACKAGING">Branded Packaging</option>
                          <option value="QUOTE">Custom Quote only</option>
                        </AppSelect>
                        <div style={{ fontSize: "0.7rem", color: "#94a3b8", fontStyle: "italic", marginTop: 3 }}>
                          Controls how buyers complete a purchase — e.g. standard checkout, requesting a custom quote, or ordering with branded packaging. Leave as "Inherit" to use the brand's default setting.
                        </div>
                      </Col>
                    </Row>
                    <Row className="g-3 mt-1">
                      <Col md={12}>
                        <Form.Label className="form-label-adorned">Prepayment Required</Form.Label>
                        <AppSelect block
                          size="sm" name="requiredPaymentMethod" value={product.requiredPaymentMethod}
                          onChange={handleInputChange} disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          className="form-control-adorned"
                        >
                          <option value="NONE">No prepayment required (COD allowed)</option>
                          <option value="ANY_ONLINE">Any online payment before acceptance</option>
                          <option value="MOMO">MTN Mobile Money only</option>
                          <option value="AIRTEL">Airtel Money only</option>
                          <option value="VISA">Credit / Debit Card only</option>
                          <option value="ZAMTEL">Zamtel Kwacha only</option>
                        </AppSelect>
                        <div style={{ fontSize: "0.7rem", color: "#94a3b8", fontStyle: "italic", marginTop: 3 }}>
                          Prepaid orders cannot be accepted or prepared until Lusuku confirms payment.
                        </div>
                      </Col>
                    </Row>
                    <Row className="g-3 mt-1">
                      <Col md={12}>
                        {/* Vendor discount: the list price above stays; the sale price is derived on read. */}
                        <DiscountFields
                          disabled={gate.lockPricing}
                          title={gate.pricingTitle}
                          value={product.discount}
                          onChange={(next) => setProduct((prev) => ({ ...prev, discount: next }))}
                          listPrice={product.price}
                        />
                      </Col>
                    </Row>
                    <hr />
                    <ProductFreightFields
                      product={product}
                      setProduct={setProduct}
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      labelClassName="form-label-adorned"
                      controlClassName="form-control-adorned"
                    />
                  </div>
                </div>

                <ProductSizeOptions product={product} setProduct={setProduct}
                  catalogueDisabled={gate.lockCatalogue} pricingDisabled={gate.lockPricing} />
                <ProductSpecificationFields product={product} setProduct={setProduct} disabled={gate.lockCatalogue} />

                <Form.Group className="mb-4">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={product.enabled}
                        onChange={(e) => {
                          const enabled = e.target.checked;
                          setProduct((prev) => ({ ...prev, enabled }));
                        }}
                        disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        color="primary"
                      />
                    }
                    label="Product Enabled"
                    className={classes.label}
                  />
                  <Form.Text className="text-muted">
                    New products start deactivated so they can be checked before customers see them. Turn this on only if this one has already been checked.
                  </Form.Text>
                </Form.Group>

                <div className="d-flex justify-content-end gap-2">
                  <Button
                    variant="secondary"
                    className="btn-adorned-secondary"
                    onClick={() =>
                      history.push("/admin/brand-product-management", {
                        brandId,
                        brandName,
                      })
                    }
                    disabled={submitting || uploading}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    className="btn-adorned-primary"
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  >
                    {submitting || uploading ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        {uploading ? "Uploading..." : "Creating..."}
                      </>
                    ) : (
                      "Create Product"
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CreateBrandProductForm;
